import React, { useState } from 'react';
import './ChatPanel.css';

const ChatPanel = ({ 
  isOpen, 
  onClose, 
  savedChats, 
  onLoadChat, 
  onDeleteChat, 
  onNewChat,
  onSearch,
  onSearchNavigate,
  translations: t
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleChatClick = (chatData) => {
    onLoadChat(chatData, searchQuery.toLowerCase());
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    onSearch(value.toLowerCase());
  };

  const filteredChats = Object.entries(savedChats)
    .filter(([title, chatData]) => {
      const lowerQuery = searchQuery.toLowerCase();

      const titleMatches = title.toLowerCase().includes(lowerQuery);

      const contentMatches = Array.isArray(chatData.messages) && chatData.messages.some(message => {
        if (typeof message.content === 'string') {
          return message.content.toLowerCase().includes(lowerQuery);
        }
        return false;
      });

      return titleMatches || contentMatches;
    })
    .sort((a, b) => {
      return new Date(b[1].timestamp) - new Date(a[1].timestamp);
    });

  return (
    <div className={`chat-panel ${isOpen ? 'open' : ''}`}>
      <div className="chat-panel-header">
        <button className="new-chat-button" onClick={onNewChat}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          {t('newChat')}
        </button>
      </div>

      <div className="chat-panel-content">
        <div className="chat-search">
          <input 
            type="text" 
            placeholder={t('searchChats')} 
            value={searchQuery}
            onChange={handleSearchChange}
          />
          {searchQuery && (
            <div className="search-navigation">
              <button
                className="search-nav-button"
                onClick={() => onSearchNavigate('prev')}
                title="Previous match"
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
              </button>
              <button
                className="search-nav-button"
                onClick={() => onSearchNavigate('next')}
                title="Next match"
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
            </div>
          )}
        </div>

        <div className="saved-chats-list">
          {filteredChats.map(([title, chatData]) => (
            <div key={title} className="chat-item">
              <div className="chat-content" onClick={() => handleChatClick(chatData)}>
                <h3>{title}</h3>
                <p className="timestamp">
                  {new Date(chatData.timestamp).toLocaleDateString()}
                </p>
              </div>
              <button
                className="delete-chat-button"
                onClick={() => onDeleteChat(title)}
                title={t('deleteChat')}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChatPanel; 